import * as React from "react"
// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

// import logo from "../images/cb-logo.svg"

// React Bootstrap
import { Container, Row, Col, Form, Button } from "react-bootstrap"

const IndexPage = () => (
  <Layout>

<div style={{ display: "grid" }}>
      {/* You can use a GatsbyImage component if the image is dynamic */}
      <StaticImage
        style={{
          gridArea: "1/1",
          // You can set a maximum height for the image, if you wish.
          // maxHeight: 600,
        }}
        className="masthead"
        placeholder="blurred"
        layout="fullWidth"
        // You can optionally force an aspect ratio for the generated image
        aspectRatio={3 / 1}
        // This is a presentational image, so the alt should be an empty string
        alt=""
        // Assisi, Perúgia, Itália by Bernardo Ferrari, via Unsplash
        src={"../images/porch.jpg"}
        quality={60}
        formats={["auto", "webp", "avif"]}
      />
      <div
        style={{
          // By using the same grid area for both, they are stacked on top of each other
          gridArea: "1/1",
          position: "relative",
          // This centers the other elements inside the hero component
          placeItems: "center",
          display: "grid",
        }}
        className="color-overlay"

      >
       
       <Container>
        <div className="text-center">
          <StaticImage 
            src="../images/compass-white-logo.png"
            alt="Portrait of Nicole Marzo"
            placeholder="blurred"
            width={150}
          />
        </div>
        <div className="d-sm-flex justify-content-center align-items-center">
        <div>
          <h1 className="pt-3 px-3 p-sm-0"><strong>Nicole Marzo</strong></h1>
          <hr />
          <p className="px-3 p-sm-0">Compass Petaluma<br />
          CalDRE #01996831
          </p>
        </div>
        <div className="px-3 ms-sm-5">
          <StaticImage 
            src="../images/nicole-marzo.jpg"
            alt="Portrait of Nicole Marzo"
            placeholder="blurred"
            width="282"
            className="mb-4 mt-sm-4"
          />
        </div>
      </div>
        
      </Container>


      </div>
    </div>
    <Container className="mb-2 mb-sm-4">
    <h2 className="text-center my-4">Featured Properties</h2>
    <p className="text-center">
        <StaticImage 
          src="../images/villa-terra-rosa.jpg"
          alt="Villa Terra Rosa"
          placeholder="blurred"
          width="750"
        />
        </p>
        <p className="text-center">
        <strong>Santa Rosa</strong> | $12.5M<br />
      <a href="https://villaterrarosa.com">Learn more about Villa Terra Rosa</a></p>

      <p className="text-center">
        <StaticImage 
          src="../images/1701-spring-hill-road.jpg"
          alt="1701 Spring Hill Road"
          placeholder="blurred"
          width="750"
        />
      </p>
      <p className="text-center">
        <strong>Petaluma</strong> | $969k <br />
        <a href="https://1701springhillrd.com">Learn more about 1701 Spring Hill Road</a></p>
          <hr />
    </Container>
    <Container className="mb-2 mb-sm-4">
      <h2 className="text-center my-4">Recent Sales</h2>
      <Row>
        <Col lg={3} md={6}>
          <p>
            <StaticImage 
              src="../images/26-Hilligoss.jpg"
              alt="26 Hilligoss"
              placeholder="blurred"
              width="500"
            /><br />
            <strong>Petaluma</strong> | $2.150M 
          </p>
        </Col>
        <Col lg={3} md={6}>
          <p>
            <StaticImage 
              src="../images/301BishopCircle.jpg"
              alt="301 Biship Circle"
              placeholder="blurred"
              width="500"
            /><br />
            <strong>Petaluma</strong> | $1.295M 
          </p>
        </Col>
        <Col lg={3} md={6}>
          <p>
            <StaticImage 
              src="../images/petaluma.jpg"
              alt="house in Petaluma, California"
              placeholder="blurred"
              width="500"
            /><br />
            <strong>Petaluma</strong> | $863,500 
          </p>
        </Col>
        <Col lg={3} md={6}>
          <p>
            <StaticImage 
              src="../images/kentucky-street.jpg"
              alt="301 Biship Circle"
              placeholder="blurred"
              width="500"
            /><br />
            <strong>Petaluma</strong>
          </p>
        </Col>
      </Row>
      <p className="text-center">
        <a href="https://www.compass.com/agents/nicole-marzo/" className="btn btn-outline-dark">View All Current and Former Listings</a>
      </p>
      <hr />
    </Container>


    <Container className="singleCol mt-3">
      <h2 className="text-center">About Nicole</h2>
      <p className="text-center lead">
Nicole Libarle Marzo is a fourth-generation Petaluma girl. </p>
      <p>After graduating from the University of Southern California, Nicole stayed in Los Angeles to work in television production. From there, she moved to Chicago to work for Merchandise Mart Properties, Inc. as a Marketing Director for home design. In Chicago, she met her husband, Richard, and they moved back to Petaluma in 2000 to raise their family and continue the family business, Lace House Linen Supply, which is an industrial linen supply business founded in 1915. They live in Petaluma with their three teenage boys and dogs, Coco and Lulu. Nicole is a member of Petaluma community Guild and the Sonoma-Marin Fair Board.</p>

      <p>Real Estate has always been in Nicole's bloodline. Her grandfather, father, uncle and other family members have been involved in the real estate business in Petaluma and Sonoma County for many decades. She is focused on impeccable service, client protection, loyalty, strong negotiating skills and stress-free transactions. As a real estate professional, Nicole has surrounded herself with the highly knowledgeable and experienced agents at Compass. </p>
      
      <p>Whether buying or selling real estate, I pledge to offer sound support and guidance to my clients, facilitating a collaborative process in a stress-free manner. Here to serve, because I cherish my clients.</p>
      
    </Container>
    <div className="lightGray mb-5 py-3">
    <Container className="singleCol">
      <h2 className="text-center my-4"><strong>Introducing Compass Concierge</strong></h2>
      <p>
      Compass Concierge is the hassle-free way to sell your home faster and for a higher price with services like staging, flooring, painting, and more.
      </p>
      <h3>How it works</h3>
      <ol>
        <li>
          Decide which services can increase your home’s value the most and set an estimated budget for the work.
        </li>
        <li>
          When you’re ready to start, your Compass agent will be by your side as you engage contractors and vendors. 
        </li>
        <li>
          Once the transformation is complete, your home will go on the market.  
        </li>
        <li>
          You’ll pay for the services and any applicable fees* when one of the following happens – your home sells, you terminate your listing agreement with Compass, or 12 months pass from your Concierge start date. Subject to program terms that may vary by market.
        </li>

      </ol>
      <p className="text-center">
        <a href="https://www.compass.com/concierge/nicole-marzo/" className="btn btn-outline-dark">Learn More & Sign Up</a>
      </p>
      
      
    </Container>

    </div>
    <Container className="singleCol">
      <blockquote className="text-left singleCol my-5">
      Nicole was an absolute pleasure to work with! We had no idea what our house-hunting journey had in store for us, especially during a pandemic. Nicole made us feel comfortable, relaxed, and confident throughout the process. She helped us stay optimistic while keeping an open mind, and without her I don’t think we would’ve found our forever home! We especially appreciated how accommodating she was, as we usually had our young children in tow. We cannot stress enough how much we enjoyed and appreciated our experience working with Nicole and the Coldwell Banker Team and would recommend them to anyone looking to find their new home. Thank you Nicole!
      <cite>Meredith</cite>
      </blockquote>
      <hr />
      <blockquote className="text-left singleCol my-5">
        Nicole handled a large group of co-owners with numerous offers and problems. She did all this extremely well and with enthusiasm.
      <cite>George</cite>
      </blockquote>
      <hr />
      <blockquote className="text-left singleCol my-5">
      I absolutely loved working with Nicole. She was knowledgeable about the area, willing to see it all with a first time home buyer & work within my hectic schedule. Nicole guided and informed me throughout the whole process! 5 stars from me!
      <cite>Katherine</cite>
      </blockquote>
      <hr />
    </Container>

    <Container>
      <h2 className="text-center py-4">Calculate Your Mortgage</h2>
      <div class="text-center">
      <iframe src="https://www.mortgagecalculator.org/free-tools/calculator/" frameborder="0" width="260px" height="270" scrolling="no" title="mortgage"></iframe>
      </div>
            
    </Container>
    <div className="lightGray mb-5 py-3">
    <Container className="singleCol">
      <h2 className="text-center my-4">Contact Nicole</h2>
      <Row className="g-4">
        <Col lg={6}>
          <p>License # CalRE# 01996831</p>
          <p>
            M: (707) 217-1386 <br />
            O: (707) 762.6611
          </p>
          <p>
            <strong>Compass Petaluma</strong><br />
            165 1st St<br />
            Petaluma, CA 94952-4292
          </p>
        </Col>
        <Col lg={6}>
          <Form 
              name="contact v1"
              method="post"
              // action="/success/"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit="submit"
          >
          {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
          <input type="hidden" name="form-name" value="contact v1" />
          <p hidden>
          <label>
              Don’t fill this out: <input name="bot-field" />
          </label>
          </p>
          <Row>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control 
                        type="text" name="first-name"
                      />
                </Form.Group>
            </Col>
              <Col md={6}>
              <Form.Group>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control 
                          type="text" name="last-name"

                        />
              </Form.Group>
              </Col>
          </Row>


              
          <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                  required
                  type="email" 
                  name="email" 
              />
          </Form.Group>

          <Form.Group>
              <Form.Label>Phone <small>(Optional)</small></Form.Label>
              <Form.Control 
                  type="text" 
                  name="phone" 
              />
          </Form.Group>
          
          <Form.Group>
              <Form.Label>How can I help you?</Form.Label>
              <Form.Control 
                  as="textarea" 
                  name="more-about-business"
                  rows="3"
              />
          </Form.Group>
          <Button type="submit">Submit</Button>
          </Form>
        </Col>
      </Row>
    </Container>

    </div>
      
  </Layout>
)

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="Nicole Marzo" />

export default IndexPage
